import { useQuery } from '@tanstack/react-query';
import { customerServices } from '../services/customer.service';

export const useCustomerAddresses = (customerId) => {
  return useQuery({
    queryKey: ['customerAddresses', customerId],
    queryFn: () => customerServices.getCustomerAddresses(customerId),
    enabled: !!customerId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
